import { WebL3Fields } from 'constants/inspectionFields';
import { Accordion1GeneralInfoL3 } from '../Accordion1GeneralInfoL3';
import { Accordion2HydraulicDataL3 } from '../Accordion2HydraulicDataL3';
import { Accordion3OvertoppingL3 } from '../Accordion3OvertoppingL3';
import { Accordion4ErosionL3 } from '../Accordion4ErosionL3';
import { Accordion5CdaL3 } from '../Accordion5CdaL3';
import { Accordion6ReportCommentsL3 } from '../Accordion6ReportCommentsL3';

// Tab L3 "Idraulica" — a differenza di L0/L1 non ha sotto-tab
// Contesto/Struttura/Servizi: un solo AccordionCustom con 6 accordion (piano
// PIANO-IMPLEMENTAZIONE-L3.md §2.1).
// Issue #1021, punto 23 — `indicatorFields` (badge "Dati Presenti: n/m",
// hooks/inspections/useCompletionInspection.js) ora popolato da
// WebL3Fields.Idraulica, stesso pattern di L0/L1 (vedi
// L0/GeneralData/config/generalData.js). "6. Commenti per report" resta
// senza `indicatorFields` di proposito — vedi commento su WebL3Fields.
export const AccordionDataL3 = [
  {
    id: '1',
    title: '1. Informazioni generali',
    content: <Accordion1GeneralInfoL3 />,
    indicatorFields: WebL3Fields.Idraulica.informazioniGenerali,
  },
  {
    id: '2',
    title: '2. Dati idraulici',
    content: <Accordion2HydraulicDataL3 />,
    indicatorFields: WebL3Fields.Idraulica.datiIdraulici,
  },
  {
    id: '3',
    title: '3. Sormonto',
    content: <Accordion3OvertoppingL3 />,
    indicatorFields: WebL3Fields.Idraulica.sormonto,
  },
  {
    id: '4',
    title: '4. Erosione',
    content: <Accordion4ErosionL3 />,
    indicatorFields: WebL3Fields.Idraulica.erosione,
  },
  {
    id: '5',
    title: '5. CdA Idraulica',
    content: <Accordion5CdaL3 />,
    indicatorFields: WebL3Fields.Idraulica.cdaIdraulica,
  },
  {
    id: '6',
    title: '6. Commenti per report',
    content: <Accordion6ReportCommentsL3 />,
  },
];
